<template>
  <div class="TeacherAndEvaluateBar">
    <div class="bar">
      <div class="left">
        <template v-if="teacherList.length > 0">
          <div class="lecture" v-for="item in teacherList" :key="item">
            <img
              src="//cdn.yuaiweiwu.com/fe/imgs/5fd17960-436b-11ef-973d-09b2b5c5fcc8-lecture_default.png"
            />
            <p>{{ item }}</p>
            <span class="icon">主讲</span>
          </div>
        </template>
        <div v-if="course.assistant_teacher" class="counseling">
          <el-popover
            placement="bottom"
            trigger="hover"
            popper-class="qrcode-popover"
            :visible-arrow="false"
            v-if="course.assistant_teacher.wechat_work_qr_code"
          >
            <div class="QRCodeWrap">
              <img :src="course.assistant_teacher.wechat_work_qr_code" />
            </div>
            <div slot="reference" class="counseling-reference">
              <img
                :src="
                  course.assistant_teacher.assistant_avatar ||
                  '//cdn.yuaiweiwu.com/fe/imgs/70739780-436b-11ef-973d-09b2b5c5fcc8-counseling_default.png'
                "
              />
              <p>
                {{ (course.assistant_teacher.assistant_name || '').substr(0, 6) }}
              </p>
              <span class="icon">辅导</span>
            </div>
          </el-popover>
          <div v-else class="counseling-reference">
            <img
              :src="
                course.assistant_teacher.assistant_avatar ||
                '//cdn.yuaiweiwu.com/fe/imgs/70739780-436b-11ef-973d-09b2b5c5fcc8-counseling_default.png'
              "
            />
            <p>
              {{ (course.assistant_teacher.assistant_name || '').substr(0, 6) }}
            </p>
            <span class="icon">辅导</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="evaluate">
          <slot name="book-course"></slot>
          <a class="comment" @click="beginComment">{{
            is_comment == 1 ? '查看评价' : '评价课程'
          }}</a>
        </div>
        <slot></slot>
      </div>
    </div>

    <el-dialog
      class="comment-dialog"
      title="评价"
      :visible.sync="showCommentDialog"
      width="784px"
      append-to-body
    >
      <div v-if="course">
        <div class="name item">课程名称：{{ course.title }}</div>
        <div class="item">
          <label>星级：</label>
          <!--        el-rate disabled为true时，动态值不生效  -->
          <el-rate v-model="commentInfo.grade"></el-rate>
          <div class="mask" v-if="is_comment == 1"></div>
          <!--          -->
        </div>
        <div class="item">
          <label>评价内容：</label>
          <br />
          <el-input
            type="textarea"
            :rows="6"
            placeholder="请输入对课程的评价内容，最多500字"
            v-model="commentInfo.content"
            :maxlength="500"
            :readonly="is_comment == 1"
          ></el-input>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitComment">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'TeacherAndEvaluateBar',
  props: {
    course: {
      type: Object,
    },
  },
  data() {
    return {
      showCommentDialog: false,
      is_comment: this.course.is_comment,
      commentInfo: {
        grade: 0,
        content: '',
      },
    };
  },
  computed: {
    teacherList() {
      return this.course.teacher_name.split(',').map((item) => item.substr(0, 6));
    },
  },
  watch: {
    course() {
      this.is_comment = this.course.is_comment;
    },
  },
  methods: {
    async beginComment() {
      this.commentInfo.grade = 5;
      this.commentInfo.content = '';
      if (this.is_comment == 1) {
        let data = await this.$http.get('/api/app/myStudy/comment/' + this.course.course_id);
        this.commentInfo.grade = data.grade;
        this.commentInfo.content = data.content;
      }

      this.showCommentDialog = true;
    },
    async submitComment() {
      if (this.is_comment == 1) {
        this.showCommentDialog = false;
        return;
      }
      if (this.commentInfo.grade == 0) {
        await this.$info('请选择星级');
        return;
      }
      if (this.commentInfo.content == '') {
        await this.$info('请输入评价内容');
        return;
      }
      await this.$http.post('/api/app/myStudy/comment', {
        grade: this.commentInfo.grade,
        content: this.commentInfo.content,
        course_id: this.course.course_id,
        type: 1,
      });
      this.showCommentDialog = false;
      this.is_comment = 1;
      await this.$success('评价成功');
    },
  },
};
</script>

<style lang="scss" scoped>
.TeacherAndEvaluateBar {
  padding: 0px 32px;
  .bar {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      display: flex;
      flex: 1;
      width: 0;
      overflow-x: auto;
      .lecture,
      .counseling,
      .counseling-reference {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        gap: 8px;
        img {
          width: 32px;
          height: 32px;
          border-radius: 50%;
        }
        p {
          font-size: 14px;
          font-weight: 500;
        }
        .icon {
          font-size: 12px;
          line-height: 20px;
          color: #f4242e;
          border-radius: 2px;
          border: 0.5px solid rgba(238, 85, 85, 0.2);
          background: #fdeeee;
          padding: 0 4px;
        }
      }
      .lecture {
        margin-right: 24px;
      }
      .counseling {
        cursor: pointer;
        position: relative;
        .icon {
          color: #015bf4;
          border: 1px solid rgba(1, 91, 244, 0.2);
          background: #e6effe;
        }
      }
      .counseling-reference {
        cursor: pointer;
        .icon {
          color: #015bf4;
          border: 1px solid rgba(1, 91, 244, 0.2);
          background: #e6effe;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      margin-left: 24px;
      .evaluate {
        display: flex;
        align-items: center;
        gap: 16px;
      }
      .comment {
        font-size: 14px;
        line-height: 20px;
        cursor: pointer;
        color: #666;
        white-space: nowrap;
        &:hover {
          color: $primary-color;
        }
      }
    }
  }
}
.comment-dialog {
  ::v-deep .el-dialog__header {
    text-align: center;
  }

  ::v-deep .dialog-footer {
    text-align: center;
    padding-top: 40px;
  }

  .item {
    padding-top: 40px;
    position: relative;
  }
  .mask {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
  }
}

.QRCodeWrap {
  width: 130px;
  height: 130px;
  padding: 7px;
  background: #fff;
  img {
    width: 130px;
    height: 130px;
    display: block;
    border-radius: 0;
  }
}
</style>

<style lang="scss">
/* 全局样式，确保弹出框样式正确 */
.qrcode-popover {
  padding: 0;
  border: none;
  background: transparent;
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.1);
}
</style>
